<template>
  <b-container v-if="this.$root.token" class="pt-3">
    <h3>{{ objectTypeRecommendations ? 'Recommendations' : 'Quick Wins' }}</h3>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-btn block href="#" v-b-toggle.accordion1 variant="primary">
          Search Criteria 
          <font-awesome-icon icon="caret-down" size="lg" v-if="!showSearch"/> 
          <font-awesome-icon icon="caret-up" size="lg" v-if="showSearch"/>
        </b-btn>
      </b-card-header>
      <b-collapse id="accordion1" visible accordion="accordion1" role="tabpanel" v-model="showSearch">
        <b-row class="pt-2" align-h="center">
          <b-col cols=6>
            <scoring-event-search 
              :skip = "{}"
              :multiple = "{
                region: true
              }"
              @update:customer = "customerId = ($event || {}).id"
              @update:industry = "industry = $event" 
              @update:country = "country = $event"
              @update:region = "regions = $event"
              @update:gear = "gear = $event"
              @update:programme = "programmeId = ($event || {}).id"
              @update:year = "year = $event"
            />
          </b-col>
          <b-col cols="6">
            <b-card>
              <h4>Search for</h4>
              <b-row class="text-left pt-2">
                <b-col>
                  <b-form-group 
                    id="keywordsGroup"
                    breakpoint="md"
                    label="Keywords"
                    label-for="keywords"
                  >
                    <vue-tags-input id="keywords" v-model="keyword" :tags="keywords" @tags-changed="newTags => keywords = newTags" placeholder="Add keywords..." />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="pt-4">
                <b-col>
                  <toggle-button id="keywordIsAnd" v-model="keywordIsAnd" :labels="{checked: 'Match ALL keywords', unchecked: 'Match ANY keywords'}" :width="150" :height="40" :switch-color="{checked: '#0069D9', unchecked: '#218838'}" :color="{checked: '#278fff', unchecked: '#30c651'}"/>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="pt-3 pb-3">
          <b-col>
            <b-button variant="success" @click="search()" v-if="!loading">Search</b-button>
          </b-col>
        </b-row>
      </b-collapse>
    </b-card>
    <b-row class="text-center">
      <font-awesome-icon v-if="searching" icon="spinner" size="lg" spin/>
    </b-row>
    <b-row class="text-center pt-3 pb-3" align-h="center">
      <toggle-button id="elements-or-dimensions" v-model="displayTable" :labels="{checked: 'Table', unchecked: 'Copy-Paste List'}" :width="150" :height="40" :switch-color="{checked: '#0069D9', unchecked: '#218838'}" :color="{checked: '#278fff', unchecked: '#30c651'}"/>
    </b-row>        
      
    <b-row class="pl-2 pr-2">
      <table class="table table-striped" v-if="results && displayTable">
        <thead>
          <tr>
            <th class="text-left">Customer</th>
            <th class="text-left">Scoring Event</th>
            <th>Gear</th>
            <th>{{ objectTypeRecommendations ? 'Recommendations' : 'Quick Wins' }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in results" :key="item.id" class='c'>
            <td class="text-left text-nowrap align-top">
              <b>{{ item.surveyRun.customer.name }}</b>
              <br>
              {{ item.surveyRun.customer.country }}
              <br v-if="item.surveyRun.customer.region">
              {{ item.surveyRun.customer.region }}
              <br>
              {{ item.surveyRun.customer.industry }} 
              <br v-if="item.surveyRun.customer.secondary_industry">
              {{ item.surveyRun.customer.secondary_industry }} 
            </td>
            <td class="text-left text-nowrap align-top">
              <router-link :to="{path: `/scoring-event/${item.surveyRun.id}`}">{{ item.surveyRun.period }} {{ item.surveyRun.year }}</router-link>
              <br>
              {{ item.surveyRun.programme.name}} Programme
            </td>
            <td class="align-top">{{ item.gear }}</td>
            <td class="text-left"><span v-html="item.text"/></td>
          </tr>
          <tr class='c' v-if="!total">
            <td colspan=100>No results</td>
          </tr>
        </tbody>
      </table>
      <ol v-if="this.results && !displayTable">
        <li v-for="item in results" :key="item.id" class="text-left">
          <span v-html="item.text"/>
        </li>
      </ol>
      <b-pagination size="sm" :total-rows="total" v-model="page" :per-page="pageSize" v-if="total > 0"/>
    </b-row>
  </b-container>

</template>
<script>
// @ is an alias to /src
import VueTagsInput from '@johmun/vue-tags-input';
import { gearDef } from '@/services/constants';
import * as _ from 'lodash';
import * as API from '@/services/API';
import ToggleButton from 'vue-js-toggle-button/src/Button';
import ScoringEventSearch from '@/components/ScoringEventSearch.vue';


export default {
  name: "QuickWinRecommendationSearch",
  components: {
    VueTagsInput,
    ScoringEventSearch,
    ToggleButton
  },
  watch: {
    page: {
      handler(newData) {
        if (newData) this.search();
      }
    },
    '$route': {
      handler(newData) {
        console.log('routechange!');
        this.initRoute();
      }
    },
    objectTypeRecommendations: {
      handler(newValue) {
        this.results = [];
      }
    }
  },
  created () {
  },
  data: function() {
    return {
      programmeId: null,
      customerId: null,
      industry: null,
      searching: false,
      gear: null,
      year: null,
      country: null,
      regions: [],
      keywords: [],
      keyword: '',
      keywordIsAnd: false,
      objectTypeRecommendations: this.$route.query.type === 'recommendations' ? true : false,
      results: [],
      total: 0,
      page: 1,
      pageSize: 500,
      showSearch: true,
      displayTable: true,
      loading: false
    }
  },
  methods: {
    initRoute() {
      if (this.$route.query.type === 'recommendations') {
        this.objectTypeRecommendations = true;    
      } else {
        this.objectTypeRecommendations = false;  
      }
    },
    search() { 
      this.searching = true;
      this.showSearch = false;
      const searchBody = {
        industry: this.industry,
        gear: this.gear,
        year: this.year,
        country: this.country,
        regions: this.regions,
        keywordType: this.keywordIsAnd ? 'and' : 'or',
        customer_id: this.customerId,
        programme_id: this.programmeId,
        keywords: (this.keywords || []).map(keyword => keyword.text),
        page: this.page,
        pageSize: this.pageSize
      };
      
      // clean out nulls
      Object.keys(searchBody).forEach(field => {
        if (!searchBody[field]) delete searchBody[field];
      });
      
      // do actual search
      API.searchQuickWinsAndRecommendations(this.objectTypeRecommendations ? 'recommendations' : 'quick-wins', searchBody, this.$root.token).then(results => {
        this.total = results.body.total;
        this.searching = false;
        this.results = Object.values(results.body.results.reduce((accumulator, row) => {

          // add this survey run if not added already.
          if (!accumulator[row.surveyRun.id]) {
            const gear = Object.keys(gearDef).reduce((accumulator, percentage) => {
              if (row.surveyRun.overall_score >= percentage) return gearDef[percentage];
              return accumulator;
            }, 0);
            accumulator[row.surveyRun.id] = row;
            accumulator[row.surveyRun.id].values = [];
            accumulator[row.surveyRun.id].gear = gear;
          }
          
          // add the recommendation or quick win.
          accumulator[row.surveyRun.id].values.push(row.recommendation || row.quick_win);
          accumulator[row.surveyRun.id].text = `<ul><li>${accumulator[row.surveyRun.id].values.join('</li><li>')}</li></ul>`;
          return accumulator;
        }, {}));
        console.log(this.results);
      });
    }
  }
}
</script>
<style>
.buttonbar {
  padding-top: 4em;
  padding-bottom: 4em;
}
</style>



// WEBPACK FOOTER //
// src/views/QuickWinRecommendationSearch.vue